.loaderOuter {
  position: relative;
}

.loaderOverlay {
  position: absolute;
  height: var(--app-main-height);
  background-color: rgb(255, 255, 255, 0.75);
  z-index: var(--z-loader);
  width: 100%;

  transition: opacity 150ms linear;
  pointer-events: none;
  opacity: 0;
  display: grid;
  place-items: center;
}

.loading {
  opacity: 1;
  pointer-events: all;
}
